import {takeEvery,call,put,delay} from 'redux-saga/effects'
import {notification,message} from 'antd'
import firebase from '../firebase'


var db = firebase.firestore()



function* authSuccess(action){
  yield put({type:"GET_USER_DATA",payload:action.payload.uid})
      yield put({type:"AUTH_SUCCESS",payload:action.payload})
       notification.success({
        message: 'Welcome',
        description:
          'Start Earning money , Click here to play quiz',
          
        onClick: () => {
          notification.destroy()
        },
        placement:"bottomRight"
      });
      
       
}
function* newUser(action){

    const data = action.payload
    // setTimeout(()=>{
    //   yield put({type:"AUTH_SUCCESS_FIRST",payload:data});
    // },3000)
   
    db.collection("users").doc(data.uid).set({
        coins:500,
        referrals:[],
        refferedBy:"",
        uid:data.uid,
        verified:false,
        lastQuiz:"",
        email:data.email,
        phoneNumber:data.phoneNumber,
        displayName:data.displayName,
        lastQuiz:Date.now() - 3600000
    }).then(function(docRef) {
    
        console.log("Document written with ID: ", docRef);
        const key = "updatable"
        message.loading({ content: 'Adding 500 Coins as SignIn Bonus...', key });
        setTimeout(() => {
            message.success({ content: 'Added!', key, duration: 3 });
        }, 3000);

    }).catch(function(error) {
        console.error("Error adding document: ", error);
    });
   
}

  
 
export default function* authSaga(){
yield takeEvery("REQUEST_AUTH_SUCCESS",authSuccess)
yield takeEvery("NEW_USER_LOGIN",newUser)
}